import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function PortalBackLink() {
  return (
    <Link className="portal-back-link" to="/" aria-label="Back to home">
      <ArrowLeft aria-hidden="true" />
      <span>Back</span>
    </Link>
  );
}
